import React, { useEffect, useState } from 'react';
import Head from 'next/head';

export default function Custom500 () {
  const [ referer, setReferer ] = useState( null );
  useEffect( () => {
    if ( document !== undefined ) {
      document.querySelector( '#__next' ).classList.add( 'h-100' )
    }
    if ( window !== undefined ) {
      setReferer( window.location.origin + '/' );
    }
  }, [referer]);
  return (
    <>
      <Head>
        <title>500 - Internal Server Error</title>
      </Head>
      <section className="h-100">
        <div className="container h-100">
          <div className="row justify-content-center align-items-center h-100 text-center">
            <div className="col-12">
              <h1>Internal Server Error!</h1>
              <h6>We are aware of this error and it will be resolved within the next 24 hours.</h6>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
